import { inject, Injectable } from '@angular/core';
import { filter, Observable } from 'rxjs';
import { Store } from '@lib.core/store/store.service';

@Injectable({providedIn: 'root'})
export class IsHeadlessStorageService {
  private readonly store = inject(Store);
  private readonly key = 'is-headless';

  setIsHeadless(isHeadless: boolean): void {
    this.store.setValue(this.key, isHeadless);
  }
  
  getIsHeadless(): Observable<boolean> {
    return this.store.getValue<boolean>(this.key).pipe(filter((v: boolean | null | undefined) => v != null));
  }
}